/**
 * Lightweight QR-style visual placeholder for the demo.
 * Renders a deterministic SVG matrix from a string seed.
 * Not a real QR — used purely for the investor demo visuals.
 */
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

const Finder = ({ x, y, cell }) => (
  <g transform={`translate(${x * cell}, ${y * cell})`}>
    <rect width={cell * 7} height={cell * 7} fill="#0B1221" />
    <rect x={cell} y={cell} width={cell * 5} height={cell * 5} fill="white" />
    <rect x={cell * 2} y={cell * 2} width={cell * 3} height={cell * 3} fill="#0B1221" />
  </g>
);

export default function QRCode({ value, size = 200, testid = "qr-code" }) {
  const N = 25;
  const cell = size / N;
  const seed = hash(value || "procred");
  const cells = [];
  for (let y = 0; y < N; y++) {
    for (let x = 0; x < N; x++) {
      const v = hash(`${seed}-${x}-${y}`);
      const isFinder =
        (x < 7 && y < 7) ||
        (x >= N - 7 && y < 7) ||
        (x < 7 && y >= N - 7);
      const filled = isFinder ? false : v % 2 === 0;
      if (filled) cells.push({ x, y });
    }
  }

  return (
    <svg
      data-testid={testid}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="block"
      role="img"
      aria-label="QR code"
    >
      <rect width={size} height={size} fill="white" />
      {cells.map((c, i) => (
        <rect
          key={i}
          x={c.x * cell}
          y={c.y * cell}
          width={cell}
          height={cell}
          fill="#0B1221"
        />
      ))}
      <Finder x={0} y={0} cell={cell} />
      <Finder x={N - 7} y={0} cell={cell} />
      <Finder x={0} y={N - 7} cell={cell} />
    </svg>
  );
}
